import { defineMessages } from 'react-intl';

const messages: {
	viewReactionsError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	replyFieldGenericError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	viewReactionsError: {
		defaultMessage: 'Reactions failed to load',
		description: 'A message shown when an error occurs when rendering reactions',
		id: 'growth.confluenceNudgeFlag.viewReactionsError',
	},
	replyFieldGenericError: {
		defaultMessage: 'Failed to send comment. Please try again later.',
		description: 'Generic error message shown when the reply field fails to send a comment',
		id: 'growth.confluenceNudgeFlag.replyFieldGenericError',
	},
});

export default messages;
